const initialState = {
  categoryList: [],
  categoryAllList: []
};

const CategoryManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CATEGORY_ALL_LIST':
      return { ...state, categoryAllList: action.payload };
    case 'CATEGORY_LIST':
      return { ...state, categoryList: action.payload };
    default:
      return { ...state };
  }
};
export default CategoryManagementReducer;
